export default function joinStrings(arr, separator = '&') {
  const last = arr.pop();
  return arr.length ? `${arr.join(', ')} ${separator} ${last}` : last;
}
